import { useEffect } from 'react';

function addScriptIfMissing(src, attrs = {}) {
  if (document.querySelector(`script[src="${src}"]`)) return null;
  const s = document.createElement('script');
  s.src = src;
  s.async = !!attrs.async;
  Object.keys(attrs).forEach(k => {
    if (k === 'async') return;
    s.setAttribute(k, attrs[k]);
  });
  document.head.appendChild(s);
  return s;
}

function addInlineScript(content, id) {
  if (id && document.getElementById(id)) return null;
  const s = document.createElement('script');
  if (id) s.id = id;
  s.type = 'text/javascript';
  s.text = content;
  document.head.appendChild(s);
  return s;
}

export default function GA() {
  useEffect(() => {
    // Add the gtag script if it's not present
    const src = 'https://www.googletagmanager.com/gtag/js?id=G-6PE42XYWWQ';
    const s = addScriptIfMissing(src, { async: true });

    // Add the inline gtag config (id'd so we don't duplicate)
    const inline = `window.dataLayer = window.dataLayer || [];\nfunction gtag(){dataLayer.push(arguments);}\ngtag('js', new Date());\n\ngtag('config', 'G-6PE42XYWWQ');`;
    const si = addInlineScript(inline, 'ga-gtag-config');

    return () => {
      // Do not remove scripts on unmount because they should remain for lifetime of app
      // If you want cleanup, uncomment the lines below.
      // if (s && s.parentNode) s.parentNode.removeChild(s);
      // if (si && si.parentNode) si.parentNode.removeChild(si);
    };
  }, []);

  return null;
}
